import { useThemeContext } from "@contexts/ThemeContext";
import { CommandBarProvider } from "@features/command-bar/CommandBarProvider";
import { useCommandBarActions } from "@features/command-bar/useCommandBarActions";
import { useSegments } from "expo-router";

const CommandBarActions = () => {
	useCommandBarActions();
	return null;
};

export const CommandBarProviderWrapper = ({
	children,
}: {
	children: React.ReactElement;
}) => {
	const { isDarkMode } = useThemeContext();
	const segments = useSegments();
	const isTabsLayoutActive = (segments as string[]).includes("(tabs)");

	if (!isTabsLayoutActive) {
		return children;
	}

	return (
		<CommandBarProvider>
			<CommandBarActions
				key={isDarkMode ? isDarkMode.toString() : "command-bar"}
			/>
			{children}
		</CommandBarProvider>
	);
};
